@if(loading()) {
<div class="centered-between">
  <mat-spinner/>
</div>
} @else if (error()) {
<div class="centered-between">
  <div class="text-error">
    {{ "error_page.general_error_message" | transloco }}
  </div>
</div>
} @else {
<div class="centered-between">
  <h2 class="loren-asset-details-photo-title">
    {{ "asset_details.photos" | transloco }} ({{ assetPhotos()?.length }})
  </h2>
  <button matButton="filled" class="btn-secondary" (click)="openUploadDialog()">
    <mat-icon>add_photo_alternate</mat-icon>
    {{ "asset_details.add_photo" | transloco }}
  </button>
</div>

<div class="loren-asset-details-photo-container">
  @for(photo of assetPhotos(); track photo) {
  <button type="button" class="loren-asset-details-photo" (click)="openDialog($index)">
    <img [src]="photo.fileImageThumbnail" alt="Photo" />
    <div class="loren-asset-details-photo-info">
      <span class="loren-asset-details-photo-key">
        {{ "asset_details.updated" | transloco }}:
      </span>
      <span class="loren-asset-details-photo-date">{{
        photo.createdOn | lorenDate
      }}</span>
      <span class="loren-asset-details-photo-key">
        {{ "asset_details.updated_by" | transloco }}: :
      </span>
      <span class="loren-asset-details-photo-value">{{ photo.createdBy }}</span>
      <span class="loren-asset-details-photo-key">
        {{ "asset_details.status" | transloco }}: :
      </span>
      <span
        class="loren-asset-details-photo-value"
        [style.color]="
          photo.assetCondition === 'VERY_GOOD'
            ? '#00966E'
            : photo.assetCondition === 'BAD' ||
              photo.assetCondition === 'VERY_BAD'
            ? '#E11D48'
            : '#000'
        "
        >{{
          "statuses." + photo.assetCondition.toLowerCase() | transloco
        }}</span
      >
      <span class="loren-asset-details-photo-key">
        {{ "asset_details.comment" | transloco }}: :
      </span>
      <span class="loren-asset-details-photo-value">{{ photo.comment }}</span>
    </div>
  </button>
  }
</div>
}
